export default {
  en: {
    headers: {
      sidebarHeaderTitle: 'Your decision',
      headerTitle: '{supplierName} / business approval request',
      headerError: 'Invalid request',
    },
    footer: {
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of use',
    },
    content: {
      stats: {
        compliance: 'Compliance',
        exemptions: 'Exemption Applied|Exemptions applied',
        remediations: 'Remediation Pending|Remediations pending',
        risks: 'Open Risk|Open risks',
        noCompliance:
          'This supplier has not yet shared their assessment answers to provide compliance information.',
      },
      evidence: 'Evidence',
      nonCompliantControls: 'Non-compliant controls',
      nonCompliantControlsPlaceholder: 'No non-compliant controls',
      openRisks: 'Open risks',
      risksPlaceholder: 'No open risks',
      risks: {
        riskTitle: 'Risk-{number}',
        open: 'Open',
        uploadTooltip: 'Files attached',
        openedBy: 'Opened by',
        description: 'Description',
        uploadedFiles: 'Uploaded files',
      },
      privateNotes: 'Private notes',
      privateNotesPlaceholder: 'No private notes',
    },
    request: {
      summary: 'Summary',
      recommendationAction: 'Recommendation action',
      approve: 'Approve',
      reject: 'Reject',
      none: 'None',
    },
    errorMessage: {
      cancelled:
        'This business approval has been cancelled, there is no further action to take, you can close this link.',
      expired:
        'This business approval has expired, there is no further action to take, you can close this link.',
      completed:
        'This business approval has been completed, there is no further action to take, you can close this link.',
      fetchError:
        'There was an error loading the business approval request. Please check the URL and try again.',
    },
    response: {
      yourApproval: 'Your approval',
      decision:
        'After looking at the information provided, and the summary and recommendation given by {requesterName}, make your approval decision by selecting one of the options below.',
      approve: 'Approve',
      reject: 'Reject',
      error: 'There was an error submitting your response. Please try again.',
      respondedMessage:
        'Thank you for submitting your response. We have notified {requesterName} about your decision.',
      respondedSubMessage: 'There is no further action to take, you can now close this link.',
      commentPlaceholder: 'Add a comment (optional)',
    },
    incomplete: {
      assessment: 'It looks like this supplier has not yet completed their assessment.',
    },
  },
};
